import { HasEquals, Vector } from 'prelude-ts';

import { RuleExecutor } from '../Rule';
import Unique from '../Unique';
import Statement from '../Statement';

/**
 * A classical logic formula.
 */
abstract class Formula extends Unique implements HasEquals {
  /**
   * Returns the dual of this formula.
   */
  abstract negated(): Formula;

  /**
   * Check if this formula is syntactically equal to another formula.
   *
   * @param that the other formula to compare this one to
   */
  abstract equals(that: Formula): boolean;

  hashCode(): number {
    // We have to implement this function to satisfy the `HasEquals`
    // interface in `prelude-ts`. However, `prelude-ts.Vector.equals`
    // never actually calls `hashCode`, so we give a bogus implementation.
    //
    // This might become an issue if we ever use `prelude-ts.Set`, but
    // until then...
    throw Error('Unimplemented');
  }

  /**
   * Return all subformulae that (recursively) appear in this one.
   * Does not include the formula itself.
   */
  abstract subFormulae(): Vector<Formula>;

  /**
   * Render a formula as HTML.
   *
   * @param subgoal statement this formula appears in
   * @param executor callback for executing actions
   */
  abstract render(subgoal: Statement, executor: RuleExecutor): JSX.Element;

  /**
   * Print out a formula as a text string
   */
  abstract toTex(): string;
}

export default Formula;
